import { Tooltip } from "@mui/material";

interface PanelActionIconProps {
  iconType: "left" | "center" | "right";
  isActive?: boolean;  
  tooltipWhenActive?: string;
  tooltipWhenInactive?: string;
  onClick: () => void;
}

export default function PanelActionIcon(props: PanelActionIconProps): JSX.Element {
  const tooltip = props.isActive ? props?.tooltipWhenActive ?? "Expand" : props?.tooltipWhenInactive ?? "Collapse";
  const lineX = props.iconType === "left" ? "9" : "15";

  return (
    <Tooltip title={tooltip}>
      <span style={{ cursor: "pointer", margin: "auto", padding: "10px" }} onClick={props.onClick}>
        <svg
          fill="none"
          height="1em"
          width="1em"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
          {props.iconType !== "center" && (
            <line x1={lineX} y1="3" x2={lineX} y2="21"></line>
          )}
        </svg>
      </span>
    </Tooltip>
  );
};
